<template>
  <footer class="site-footer">
    <div class="site-container site-footer__grid">
      <div class="footer-lead">
        <h2>Asegure sus operaciones.</h2>
        <p>
          Consultoría especializada para equipos que necesitan reducir riesgo biológico, ordenar decisiones técnicas y
          sostener estándares exigentes.
        </p>
      </div>

      <div class="footer-column">
        <h3>Navegación</h3>
        <router-link to="/">Inicio</router-link>
        <router-link :to="{ path: '/', hash: '#servicios' }">Servicios</router-link>
        <router-link to="/insights">Publicaciones</router-link>
        <router-link :to="{ path: '/', hash: '#contacto' }">Contacto</router-link>
      </div>

      <div class="footer-column">
        <h3>Contacto</h3>
        <a href="mailto:jlamela005@gmail.com">jlamela005@gmail.com</a>
        <a href="https://wa.me/59898300386" target="_blank" rel="noopener">WhatsApp</a>
        <a href="https://www.linkedin.com/in/julio-c%C3%A9sar-lamela-94743647/" target="_blank" rel="noopener">LinkedIn</a>
      </div>

      <div class="footer-column footer-column--meta">
        <h3>JL Consultorías</h3>
        <p>Microbiología y seguridad alimentaria aplicada con precisión.</p>
        <p>&copy; {{ year }} JL Consultorías.</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'StarterFooter',
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>

<style lang="scss" scoped>
.site-footer {
  background: var(--bg-dim);
  border-top: 1px solid rgba(59, 73, 76, 0.45);
}

.site-footer__grid {
  display: grid;
  gap: 2rem;
  padding-top: 3rem;
  padding-bottom: 3rem;
}

.footer-lead {
  max-width: 28rem;
}

.footer-lead p {
  color: var(--text-color);
}

.footer-column {
  display: grid;
  gap: 0.75rem;
}

.footer-column h3 {
  margin-bottom: 0.25rem;
  font-size: 0.9rem;
  text-transform: uppercase;
}

.footer-column a,
.footer-column p {
  margin: 0;
  color: var(--text-color);
  font-size: 0.95rem;
}

.footer-column--meta p:last-child {
  color: var(--muted-color);
  font-family: var(--font-mono);
  font-size: 0.8rem;
}

@media (min-width: 900px) {
  .site-footer__grid {
    grid-template-columns: 1.4fr 0.8fr 0.8fr 0.9fr;
    align-items: start;
  }
}
</style>
